import {Component, inject} from '@angular/core';
import {AsyncPipe, NgClass} from '@angular/common';
import {NotificationService} from '../notify_service/notify.service';

@Component({
  selector: 'app-notification',
  imports: [
    NgClass,
    AsyncPipe
  ],
  templateUrl: './notification.html',
  styleUrl: './notification.scss',
})
export class Notification {
  service = inject(NotificationService);
}
